<template>
  <div class="wrapper_group_dashboard">
    <div class="group_dashboard">
      <div class="all_invoices">
        <breadcrumb :items="breadcrumbItems" class="invoice-detail-breadcrumb" />
        <div class="title">
          <h2>Multi Group Payment History</h2>
        </div>

        <p v-if="errorMessage" class="text-danger mg_message">{{ errorMessage }}</p>

        <template v-else-if="loaded">
          <div v-if="groupInfo" class="mg_group_header">
            <div v-if="groupInfo.name"><strong>{{ groupInfo.name }}</strong></div>
            <div v-if="groupInfo.address1">{{ groupInfo.address1 }},</div>
            <div v-if="groupInfo.address2">{{ groupInfo.address2 }},</div>
            <div v-if="groupInfo.city">{{ groupInfo.city }}, {{ groupInfo.state }}, {{ groupInfo.zip }}</div>
            <div v-if="groupInfo.email">{{ groupInfo.email }}</div>
            <div v-if="groupInfo.phone">{{ groupInfo.phone }}</div>
          </div>

          <div class="table_container" style="overflow-x: auto">
            <table>
              <thead>
                <tr>
                  <td>Payment ID</td>
                  <td>Payment Date</td>
                  <td>Payment Method</td>
                  <td>Payment Amount</td>
                  <td>Status</td>
                  <td>Notes</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(payment, index) in payments" :key="payment.payment_id || index">
                  <td>{{ payment.payment_id }}</td>
                  <td>{{ payment.payment_date | date_format("YYYY-MM-DD", "MM/DD/YYYY") }}</td>
                  <td>{{ payment.payment_method }}</td>
                  <td>{{ payment.payment_amount | currency }}</td>
                  <td>{{ payment.payment_status }}</td>
                  <td>{{ payment.payment_notes }}</td>
                </tr>
              </tbody>
            </table>
            <no-content v-if="!payments.length" text="No payments available." />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";

export default {
  name: "MultiGroupPaymentHistory",
  data() {
    return {
      breadcrumbItems: [
        { title: "Multi Group Payment History", active: true },
      ],
      groupInfo: null,
      payments: [],
      loaded: false,
      errorMessage: "",
    };
  },
  methods: {
    getPaymentHistory() {
      let loader = this.$loading.show();
      Api.get(`multigroup-invoice/${this.$route.params.invoiceId}/payment-history`)
        .then((res) => {
          this.groupInfo = res.data.data.group_info;
          this.payments = res.data.data.payments || [];
          this.loaded = true;
        })
        .catch((err) => {
          if (err && err.response && err.response.status === 403) {
            this.errorMessage = "You are not authorized to view multi-group invoices.";
            return;
          }
          this.errorMessage = "Failed to load payment history.";
          this.$notify(this.errorMessage, "error");
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getPaymentHistory();
  },
};
</script>
<style src="@/assets/css/group_dashboard/all_invoices.css"></style>
<style scoped>
.mg_group_header {
  margin-top: 15px;
  color: #254050;
  line-height: 24px;
}
.mg_message {
  margin-top: 20px;
}
</style>
